import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './services/filter'

import { initializeApp } from "firebase/app";

import VueSweetalert2 from 'vue-sweetalert2'

import 'sweetalert2/dist/sweetalert2.min.css'

require('dotenv').config()

const firebaseConfig = {
    apiKey: "AIzaSyDH8KLAvrZ7E51nHwYNPQlaPMqvpeMv82Q",
    authDomain: "kubelajar-apk.firebaseapp.com",
    projectId: "kubelajar-apk",
    storageBucket: "kubelajar-apk.appspot.com",
    messagingSenderId: "334547183131",
    appId: "1:334547183131:web:2d1744ba5f556ce43b3abe",
    measurementId: "G-6JLG2LYDFH"
};

initializeApp(firebaseConfig);

Vue.use(VueCookie)
Vue.use(VueSweetalert2)

import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import Skeleton from 'vue-loading-skeleton'
// import "vue-loading-skeleton/dist/style.css"
Vue.use(Skeleton)

// Import the component
import VueSkeletonLoader from 'skeleton-loader-vue'

// Register the component globally
Vue.component('vue-skeleton-loader', VueSkeletonLoader)

import VCalendar from 'v-calendar'
Vue.use(VCalendar, {componentPrefix: 'vc'})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')